import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";

import { AccountType } from "users/account-types/account-type";
import Guid from "_shared/guids/guid";
import VendorTeamName from "work/work-agreements/teams/vendor-team/vendor-team-name/vendor-team-name";
import EntityMemberCommand from "_shared/entity-members/_api/commands/entity-member-api-command";
import { TeamTemplateParty } from "work/team-templates/team-template-party";

export default class TeamTemplateAPIRequest {
  entityId?: string;
  name?: string;
  leader?: EntityMemberCommand;
  members?: EntityMemberCommand[];
  creatorType?: string;
  marketplaceId?: string;
  /**
   * Which side's roster is being saved — see {@link TeamTemplateParty}.
   *
   * Always sent, including for the vendor side, so that a template's side is stated by whoever is
   * saving it rather than inherited from a default two layers away. The server still defaults it to
   * Vendor for callers that say nothing.
   */
  party: TeamTemplateParty;

  constructor(
    entityId: Guid,
    team: VendorTeam,
    name: VendorTeamName,
    creatorType: AccountType,
    marketplaceId?: Guid,
    party: TeamTemplateParty = TeamTemplateParty.Vendor
  ) {
    this.entityId = entityId.value;
    this.name = name.value;
    this.leader = team.leader ? new EntityMemberCommand(team.leader) : undefined;
    this.members = team.members.map(member => new EntityMemberCommand(member));
    this.creatorType = creatorType;
    this.marketplaceId = marketplaceId?.value;
    this.party = party;
  }
}